import { useDetailsResource } from 'framework/ViewTypes/hooks';
import { useParams } from 'react-router-dom';
import useRecruitmentPoolService from '../../useRecruitmentPoolService';

const useRecruitmentPoolDetails = () => {
  const { id } = useParams<{ id: string }>();
  const { getById } = useRecruitmentPoolService();
  const { data: recruitmentPool, setData: setRecruitmentPool, ...state } = useDetailsResource(id, getById);

  return { recruitmentPool, setRecruitmentPool, ...state };
};

export default useRecruitmentPoolDetails;
